
import Vue, { PropType } from 'vue'
import { TranslateResult } from 'vue-i18n'
import { siteUserPageUrl } from '~/assets/ts/utils/urls'
import { PasswordModalSubmitEvent } from '~/assets/ts/utils/site'
import SiteFieldSection from '~/components/site/FieldSection.vue'
import SitePasswordInput from '~/components/site/PasswordInput.vue'
import SiteButton from '~/components/site/Button.vue'
import SiteButtonSpinner from '~/components/site/ButtonSpinner.vue'
import { ToastApiError, ToastError } from '~/assets/ts/utils/toast'

export default Vue.extend({
  name: 'SitePasswordModalContents',
  components: {
    SiteButtonSpinner,
    SiteButton,
    SitePasswordInput,
    SiteFieldSection,
  },
  props: {
    submitEvent: {
      type: Function as PropType<PasswordModalSubmitEvent>,
      required: true,
    },
    placeholder: {
      type: String as PropType<TranslateResult>,
      required: true,
    },
  },
  data() {
    return {
      password: '',
      submitting: false,
    }
  },
  computed: {
    learnMoreUrl(): string {
      return siteUserPageUrl('about')
    },
  },
  methods: {
    closeModals() {
      this.$modal.hide('password')
    },
    async submitPassword() {
      this.submitting = true
      try {
        const success = await this.submitEvent(this.password)
        if (!success) {
          ToastError(this.$t('Incorrect Password'))
        } else {
          this.closeModals()
        }
      } catch (e) {
        ToastApiError(e, this)
      }
      this.submitting = false
    },
  },
})
